import TF from '../TextField'

import createWrappedField from './createWrappedField'

export default createWrappedField({
  Component: TF,
  name: 'DDITextField'
})
